import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class StandardAppGuard implements CanActivate {
  canActivate(): boolean {
    // This is a placeholder implementation
    // In a real app, you would check if the current module is app.standard.module
    // For example, by checking a value from the environment or a service

    // For now, we'll just check if we're not in an iframe
    return !this.isInIframe();
  }

  private isInIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
}
